import { Component, OnInit, Input } from "@angular/core";

@Component({
  selector: "user-form",
  template: require('./userform.component.html'),
  styles: [require('./userform.component.scss')]
})
export class UserFormComponent implements OnInit {
  @Input("users") users: any[];
  @Input("panels") panels: string[];
  @Input("editMode") editMode: boolean[];
  @Input("projects") projects: any[];
  activePanels: string[];
  projectIds: number[] = [];
  role: string[] = [];

  constructor() {}

  ngOnInit() {
    this.activePanels = this.panels || ["details"];
  }

  getTitle(user: any) {
    if (this.users.length > 1) {
      return user.name || "Write a name";
    }
    return "Details";
  }

  deleteUser(index: number) {
    if (index > -1) {
      this.users.splice(index, 1);
    }
  }

  // checkPassword(user: any) {
  //   return !!(!this.editMode || (user.password && user.password !== ''));
  // }

  removeListItem(field: string, id: string, user: any) {
    let array = user[field];
    let index = array.indexOf(id);
    if (index > -1) {
      array.splice(index, 1);
    }
  }

  removeProject(index: number, user: any) {
    //let index = user.projects.indexOf(user.projects.filter(item => {return item.id === projectId; })[0]);
    if (index > -1) {
      if (this.editMode && !user.projects[index].isNew) {
        user.projects[index].isDelete = true;
      } else {
        user.projects.splice(index, 1);
      }
    }
  }

  addProject(projectId: any, user: any, role: string) {
    if (projectId) {
      let project = this.projects.filter((it) => {
        return it.id === projectId;
      })[0];
      if (!user.projects) {
        user.projects = [];
      }
      let newProject;
      newProject = { id: project.id, name: project.name, role: role };
      if (this.editMode) {
        newProject.isNew = true;
      }
      user.projects.push(newProject);
      this.projectIds = [];
      this.role = [];
    }
  }

  getUserProjects(user: any): any[] {
    if (this.projects && this.projects.length > 0) {
      let projectList = [];
      if (user.projects) {
        user.projects.map((item) => {
          let project = this.projects.filter((it) => {
            return it.id === item.id;
          });
          if (project.length > 0) {
            projectList.push(Object.assign({}, item));
          }
        });
      }
      user.projects = projectList;
      if (projectList.length > 0) {
        return projectList;
      } else {
        return;
      }
    } else {
      this.users.map((usr) => {
        usr.projects = [];
      });
      return;
    }
  }

  hasProject(id: string, user: any) {
    return (
      user.projects &&
      user.projects.length > 0 &&
      user.projects.filter((it) => {
        return it.id === id && !it.isDelete;
      }).length > 0
    );
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/users/userform.component.ts